import { Deserializable } from "./Deserializable";

export class EstructuraDinamicaField implements Deserializable {
  name?: string;
  type?: string;
  length?: string;
  nullable?: boolean;
  visible?: boolean;
  editable?: boolean;
  vistaPrevia?: boolean;
  vistaPreviaTwo?: boolean;
  preview?: boolean;
  children?: string;
  label?: string;
  inputType?: string;
  pattern?: string;
  width?: string;
  value?: string | any;
  values?: ValuesDetails;
  subFields?: any;
  associateField?: string;
  section?: string;
  order?: string;
  columnOrder?: string | null;
  msgModal?: string;
  periodsField?: boolean;
  nominative?: boolean;
  template?: any;
  hash?: boolean; // PII/Hash
  dependency?:any;
  isMultiSelect?: boolean;
  isSearchable?: boolean;

  constructor() {
    // This is intentional
  }

  deserialize(input: any): this {
    Object.assign(this, input);
    return this;
  }
}

class ChangeDetails {
  fieldToChange?: string;
  newValue?: string;
}

export class ValuesDetails {
  value?: string;
  text?: string;
}

// Generated by https://quicktype.io

export interface Field {
  name: string;
  type: string;
  length: string;
  nullable: boolean;
  visible: boolean;
  editable: boolean;
  vistaPrevia: boolean;
  mkey: boolean;
  preview: boolean;
  children: string;
  label: string;
  inputType: string;
  pattern: string;
  width: string;
  value: null;
  values: null;
  subFields: null;
  associateField: string;
  section: string;
  order: string;
  columnOrder: string;
  msgModal: string;
  periodsField: boolean;
  nominative: boolean;
}
